import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import submit from "submit-form";
import SvgIcon from "../../../../parts/SvgIcon";
import { getLoadAndUnit } from "../../../../utils/converters/convert-units";

const ClientGoals = (props) => {
  const { t } = useTranslation("athlete-portal");
  const { locals } = props;

  const clientGoals = locals?.clientGoals;
  const anyGoalCompleted = clientGoals.filter((goal) => !!goal.completed);

  return (
    <div className="goals-display">
      <div className="goals-section">
        <GoalSection
          clientGoals={clientGoals}
          title={t("clientGoals.personalRecordGoals")}
          goalType={"personalRecord"}
          activeUser={locals?.activeUser}
          completed={false}
        />

        <GoalSection
          clientGoals={clientGoals}
          title={t("clientGoals.customGoals")}
          goalType={"custom"}
          activeUser={locals?.activeUser}
          completed={false}
        />
      </div>
      {anyGoalCompleted.length > 0 && (
        <>
          <div className="separator"></div>
          <div className="goals-section">
            <GoalSection
              clientGoals={clientGoals}
              title={t("clientGoals.personalRecordsAchieved")}
              goalType={"personalRecord"}
              activeUser={locals?.activeUser}
              completed={true}
            />

            <GoalSection
              clientGoals={clientGoals}
              title={t("clientGoals.customGoalsAchieved")}
              goalType={"custom"}
              activeUser={locals?.activeUser}
              completed={true}
            />
          </div>
        </>
      )}
    </div>
  );
};

const GoalSection = ({
  clientGoals,
  title,
  goalType,
  completed,
  activeUser,
}) => {
  const { t } = useTranslation("common");
  return (
    <article>
      {!completed ? <header>{title}</header> : <p>{title}</p>}
      <ul>
        {clientGoals &&
          clientGoals.length > 0 &&
          clientGoals.map((goal) => {
            if (
              goal.type === goalType &&
              Boolean(goal.completed) === completed
            ) {
              return (
                <GoalItem
                  goal={goal}
                  key={`${goal._id}`}
                  activeUser={activeUser}
                />
              );
            }
          })}
      </ul>
      {!completed && (
        <button
          data-button-type="outline"
          onClick={() => {
            submit("/actions/refresh?", {
              method: "GET",
              body: {
                "modal[type]": "add-client-goal",
                modalState: goalType,
              },
            });
          }}
        >
          {t("add")}
        </button>
      )}
    </article>
  );
};

const GoalItem = ({ goal, activeUser }) => {
  const { t } = useTranslation(["athlete-portal", "common"]);
  const [opened, setOpened] = useState(false);

  return (
    <li>
      <div>
        <DisplayGoalLabel goal={goal} activeUser={activeUser} />

        <div>
          <details role="list" open={opened}>
            <summary
              onClick={(e) => {
                e.preventDefault();
                setOpened(!opened);
              }}
              onBlur={(e) => {
                e.preventDefault();
                setOpened(false);
              }}
            >
              <SvgIcon src="/img/new-icons/vuesax-linear-add-square.svg" />
            </summary>
            <ul role="listbox" className={opened ? "opened" : ""}>
              {!goal.completed && (
                <li
                  onMouseDown={() => {
                    submit("/actions/refresh?", {
                      method: "GET",
                      body: {
                        "modal[type]": "add-client-goal",
                        modalState: goal.type,
                        goalId: goal._id,
                      },
                    });
                  }}
                >
                  <a>{t("common:edit")}</a>
                </li>
              )}
              <li
                onMouseDown={() => {
                  submit(
                    `/actions/client-goals/complete-client-goal/${goal._id}`,
                    {
                      method: "POST",
                      body: {
                        completed: !goal.completed,
                        goals: [goal._id],
                      },
                    }
                  );
                }}
              >
                <a>
                  {t(
                    goal.completed
                      ? "clientGoals.markAsIncomplete"
                      : "clientGoals.markAsComplete"
                  )}
                </a>
              </li>
              <li
                onMouseDown={() => {
                  submit(
                    `/actions/client-goals/delete-client-goal/${goal._id}`,
                    {
                      method: "GET",
                    }
                  );
                }}
              >
                <a className="text-(--danger)!">{t("common:delete")}</a>
              </li>
            </ul>
          </details>
        </div>
      </div>
    </li>
  );
};

const DisplayGoalLabel = ({ goal, activeUser }) => {
  if (goal.type === "custom")
    return (
      <article className="goal-item">
        <div className="goal-item-with-icon">
          {!!goal.completed && <div className="chip success"></div>}
          <SvgIcon
            src={`/img/new-icons/${goal.details.customIcon}.svg`}
            classNames="goal-icon"
          />
          <p>{goal.details.customName}</p>
        </div>
        <p>{goal.details.customTarget}</p>
      </article>
    );

  if (goal.type === "personalRecord") {
    const { value: loadValue, unit } = getLoadAndUnit(
      goal.details.targetLoad,
      activeUser.units
    );

    return (
      <article className="goal-item">
        <div className="goal-item-with-icon">
          {!!goal.completed && <div className="chip success"></div>}
          <p>{goal.details.targetName}</p>
        </div>
        <p>
          {goal.details.targetReps} reps @ {`${loadValue} ${unit}`}
        </p>
      </article>
    );
  }

  return <></>;
};

export default ClientGoals;
